import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
 import "./App.css";  
import Home from "./pages/home/Home"; 
import HeaderTop from "./Header";
import Footer from "./Footer"; 
import CmsPage from "./pages/CmsPage";  
import TestimonialForm from "./pages/TestimonialForm"; 
import FeedbackPage from "./pages/FeedbackPage";  
import ScrollToTop from "./pages/ScrollToTop";
import ContactPage from "./pages/ContactPage";   
import TurfBooking from "./pages/TurfBooking";
import PaymentPage from "./pages/PaymentPage";
function App() { 
  return (
    // <Router basename="/demo/turf63">
    <Router>
      <ScrollToTop />
      <HeaderTop/> 
      <Routes> 
        <Route path="/" element={<Home  />} />  
        <Route path="/testimonials" element={<FeedbackPage />} />
        <Route path="/booking" element={<TurfBooking />} />
        <Route path="/feedback-form" element={<TestimonialForm />} /> 
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/:slug" element={<CmsPage />} /> 
        <Route path="/payment" element={<PaymentPage />} /> 
      </Routes>

      <Footer />
    </Router>
  );
}
export default App;